// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export class UserDelegationKeyCredential {}
